import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  text?: string;
  imgSrc?: string;
  bgColor?: string;
  fontColor?: string;
  className?: string;
  onClick?: () => void;
  rs?: string;
  isAd?: boolean;
}

const QuickMenuBtn2 = ({
  text,
  imgSrc,
  bgColor,
  fontColor,
  className,
  onClick,
  rs,
  isAd = false,
}: IProps) => {
  const cName = classNameBind(['quick-menu-btn-new', className || '']);

  return (
    <S.QuickMenuBtn2
      className={cName}
      bgColor={bgColor || '#f6f6f6'}
      fontColor={fontColor || '#000'}
      hasImg={!!imgSrc}
      onClick={onClick}
    >
      {imgSrc && <Img src={getResizeImageUrl(imgSrc, rs)} />}
      <Text>{text}</Text>
      {isAd && <span className="ad-tag">AD</span>}
    </S.QuickMenuBtn2>
  );
};

export default memo(QuickMenuBtn2);
